import type { DeliveryGroup } from '@/modules/shippingMethod/domain/ShippingMethod';

export const TAB_SHIPPING = 'despacho';
export const TAB_PICKUP = 'retiro';

export const BUY_NOW_MOCK_GROUP: DeliveryGroup = {
  id: '8108ce1d-b156-4b68-b72c-4151eeaf1a59',
  title: 'Entrega',
  iconName: 'il-product',
  intangible: false,
  productList: [
    {
      onDelete: () => {},
      productId: 'e822705f-40e9-4cf5-8366-a29e6c34972c',
      quantity: 1,
      productSKU: '913259999',
      name: 'LED Smart TV 50 4K UHD 50A6N + Soundbar HS205',
      imageUrl:
        'https://cl-dam-resizer.ecomm.cencosud.com/unsafe/adaptive-fit-in/792x1068/cl/paris/913259999/variant/687906a0e03433c0e52d32b4/images/93973d45-7623-43f8-a393-cd8cd7d3c1db/913259999-0000-001.jpg',
      saleTagProps: {
        storeName: 'Paris',
        label: 'Vendido por:'
      },
      isPreSale: false,
      specs: [
        {
          label: 'Color',
          value: 'Único Color'
        }
      ],
      services: [
        {
          title: '1A G EXT+1A DAÑO',
          amount: '1',
          type: 'warranty'
        },
        {
          title: 'INSTALACION',
          amount: '1',
          type: 'installation'
        }
      ]
    }
  ],
  pickupOptions: [
    {
      id: '88',
      title: 'Paris Temuco Centro',
      brand: 'paris',
      selected: false,
      radioButton: {
        id: '88',
        name: 'Paris Temuco Centro',
        value: '88'
      },
      deliveryDateFrom: '2025-08-28T14:21:22.000-0400',
      deliveryDateTo: '2025-08-28T14:21:22.000-0400',
      shippingType: 'COLLECT',
      shippingSubType: 'IN_STORE',
      shippingMethod: 'SCHEDULED',
      collectNodeCode: '88',
      originNodeCode: '88',
      originNodeType: 'STORE',
      shipDate: '2025-08-28T14:21:22.000-0400',
      hasCommuneOption: true,
      description1Label: 'Retira desde:',
      description1Value: '5 de Abril',
      description2: 'Arturo Prat 444, Temuco',
      isFree: true,
      showBorder: false
    },
    {
      id: '100',
      title: 'Punto Blue Express Copec Camino a Coñaripe 555',
      brand: 'copec',
      selected: false,
      radioButton: {
        id: '100',
        name: 'Punto Blue Express Copec Camino a Coñaripe 555',
        value: '100'
      },
      deliveryDateFrom: '2025-08-28T14:21:22.000-0400',
      deliveryDateTo: '2025-08-28T14:21:22.000-0400',
      shippingType: 'COLLECT',
      shippingSubType: 'IN_STORE',
      shippingMethod: 'SCHEDULED',
      collectNodeCode: '100',
      originNodeCode: '100',
      originNodeType: 'STORE',
      shipDate: '2025-08-28T14:21:22.000-0400',
      hasCommuneOption: true,
      description1Label: 'Retira desde:',
      description1Value: '8 de Abril',
      description2: 'Arturo Prat 444, Temuco',
      isFree: false,
      showBorder: false,
      price: '$3.990'
    }
  ],
  shippingOptions: [
    {
      id: 'delivery-8108ce1d-b156-4b68-b72c-4151eeaf1a59-0',
      selected: true,
      label: 'Recibe mañana: ',
      date: '28 de agosto',
      description: 'Entre 09:00 y 21:00',
      shipDate: '2025-08-28T08:00:00.000-0400',
      deliveryDateFrom: '2025-08-28T09:00:00.000-0400',
      deliveryDateTo: '2025-08-28T09:00:00.000-0400',
      logisticsModel: 'OWNED',
      originNodeAdmin: 'PARIS',
      originNodeCode: '400',
      originNodeType: 'WAREHOUSE',
      shippingType: 'DELIVERY',
      shippingSubType: 'HOME',
      shippingMethod: 'NEXT_DAY',
      timeSlot: {
        name: 'TH',
        deliveryTimeStart: '08:59',
        deliveryTimeEnd: '23:59'
      },
      price: '$9.990',
      isFlash: false,
      chips: []
    }
  ],
  classificationGroupMeta: {
    shippingTypeIndex: 'DELIVERY',
    shippingSubTypeIndex: 'HOME',
    shippingMethodIndex: 'NEXT_DAY',
    productClassificationIndex: 'REGULAR',
    sellerTypeIndex: '1P',
    sellerNameIndex: 'Paris',
    deliveryDateFromIndex: '2025-08-28',
    deliveryDateToIndex: '2025-08-28',
    // timeSlotIndex: 'TH',
    originNodeCodeIndex: '400'
  }
};

export const FEES_OPTIONS_MOCK = [
  { label: '1 cuota', value: '1' },
  { label: '3 cuotas', value: '3' },
  { label: '6 cuotas', value: '6' },
  { label: '12 cuotas', value: '12' }
];
